import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form/immutable';
import { IconButton } from '@material-ui/core';
import DeleteIcon from '@mui/icons-material/Delete';
import FormControl from '@material-ui/core/FormControl';

import FormTextField from 'retired/FormTextField';
import makeSortableItem from 'retired/SortableItem';
import * as validators from 'utils/validators';
import { primaryBlue } from 'utils/color-styles';
import FormFieldLabel from 'retired/FormFieldLabel';

import SectionsSelector from './SectionsSelector';

const required = validators.required();

const Section = ({ questionId, question, remove, sections, currentSection, isSurvey }) => (
  <>
    <div
      style={{
        backgroundColor: primaryBlue,
        color: 'white',
        marginTop: 45,
        display: 'inline-block',
        paddingTop: 5,
        paddingBottom: 2,
        paddingLeft: 15,
        paddingRight: 15,
        borderTopLeftRadius: 5,
        borderTopRightRadius: 5,
      }}
    >
      Section {currentSection} of {sections.size}
    </div>
    <div
      style={{
        border: '1px solid rgba(0, 0, 0, 0.2)',
        borderTop: `4px solid ${primaryBlue}`,
        padding: 15,
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <FormControl style={{ marginBottom: 15 }}>
          <Field
            name={`${question}.title`}
            component={FormTextField}
            placeholder="Section title"
            validate={required}
            required
          />
        </FormControl>
        <FormControl>
          <Field
            name={`${question}.description`}
            component={FormTextField}
            placeholder="Section description"
            multiline
          />
        </FormControl>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            marginTop: 30,
            marginBottom: 15,
          }}
        >
          <FormControl style={{ flexGrow: 1 }}>
            <FormFieldLabel>After this section:</FormFieldLabel>
            <Field
              name={`${question}.typeConfiguration.nextSection`}
              component={SectionsSelector}
              title="Next section"
              sections={sections.filter((section) => section.get('_id') !== questionId)}
              isSurvey={isSurvey}
              style={{ width: 300 }}
            />
          </FormControl>
          <IconButton title="Delete section" onClick={remove} tooltip="bottom-right">
            <DeleteIcon />
          </IconButton>
        </div>
      </div>
    </div>
  </>
);
Section.propTypes = {
  sections: PropTypes.object,
  questionId: PropTypes.string,
  question: PropTypes.string,
  currentSection: PropTypes.number,
  remove: PropTypes.func,
  isSurvey: PropTypes.bool,
};
export default makeSortableItem({
  itemType: 'question',
  wrapperStyle: {
    position: 'relative',
    maxWidth: 1000,
    paddingTop: 6,
    paddingBottom: 2,
  },
})(Section);
